module.exports = __webpack_public_path__ + "img/overtime.472c88a6.jpg";